module.exports = __webpack_public_path__ + "static/media/18.af1eacb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/18.png
// module id = 520
// module chunks = 0